import { render } from "./AllowanceTypesManagement.vue?vue&type=template&id=6767e53b&scoped=true"
import script from "./AllowanceTypesManagement.vue?vue&type=script&lang=js"
export * from "./AllowanceTypesManagement.vue?vue&type=script&lang=js"

import "./AllowanceTypesManagement.vue?vue&type=style&index=0&id=6767e53b&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6767e53b"]])

export default __exports__